import React from 'react';
import { NylasSchedulerEditor } from '@nylas/react';
import { getAxiosClient } from '../../http.client';
// @TODO: FLU-193 Handle this.
class CustomIdentityRequestWrapper {
    grantId;
    constructor(grantId) {
        // Initialize the class
        this.grantId = grantId;
    }
    async request(args) {
        try {
            const makeRequestViaProxy = async (args) => {
                const api = await getAxiosClient("scheduling");
                return (await api.post('/integration/proxy', { args })).data;
            };
            const response = await makeRequestViaProxy(args);
            return [response, null];
        }
        catch (error) {
            console.error('Fetch error:', error);
            return [null, error];
        }
    }
    /**
     * This method returns the current user's information.
     */
    async currentUser() {
        try {
            const getGrant = async () => {
                const api = await getAxiosClient("scheduling");
                return (await api.get('/grant')).data;
            };
            const grant = await getGrant();
            if (grant.data?.grant_status !== 'valid') {
                return null;
            }
            return {
                id: grant.data?.id,
                email: grant.data?.email,
                name: grant.data?.name,
                provider: grant.data?.provider,
            };
        }
        catch (error) {
            return null;
        }
    }
    /**
     * This method sets the default authentication arguments to use when authenticating the user.
     */
    async setDefaultAuthArgs(authArgs) {
        // Set the default authentication arguments.
        return authArgs;
    }
    ;
    /**
     * This method returns the URL to redirect the user to for authentication.
     */
    async authenticationUrl() {
        return `${window.location.origin}/integrations/scheduling`;
    }
}
export const SchedulerEditorPage = ({ integration }) => {
    const urlParams = new URLSearchParams(window.location.search);
    const configId = urlParams.get("config_id") || "";
    const nylasApiRequest = new CustomIdentityRequestWrapper(integration.grantId);
    return (React.createElement("div", { className: "bg-white border border-gray-200 rounded-xl w-full max-w-[960px] mx-auto" },
        React.createElement("style", null, `
        /* Remove top bar and close button for a cleaner, minimal look */
        nylas-scheduler-editor::part(nse__close-button){ display: none; }
        nylas-scheduler-editor::part(nse__header){ display: none; }
        // nylas-scheduler-editor::part(nlc__create-new-cta){ display: none; }

        /* Let the editor height be driven by content */
        nylas-scheduler-editor { display: block; height: auto !important; width: 100% !important; }
        // nylas-scheduler-editor::part(nse__content){ padding: 0; height: auto !important; width: 100% !important; }
        nylas-scheduler-editor::part(nse__list-configurations){ border-right: 1px solid #f3f4f6; max-height: none !important; }
      `),
        React.createElement(NylasSchedulerEditor, { schedulerPreviewLink: `${window.location.origin}/scheduling/meet?config_id={config.id}`, nylasApiRequest: nylasApiRequest, themeConfig: {
                "--nylas-primary": "#f97316",
                "--nylas-base-100": "#ffffff",
                "--nylas-base-200": "#f8fafc",
                "--nylas-border-radius": "10px"
            }, defaultSchedulerConfigState: {
                selectedConfiguration: {
                    requires_session_auth: false,
                }
            } })));
};
export default SchedulerEditorPage;
